<template>
  <div class="autocompleteAirport">
    <div class="inputText" @keydown.tab="checkInput()">
      <div v-if="showInputLabel"
           class="inputText__label"
           :for="name"
      >
        {{ label }}*
      </div>
      <div class="inputText__group">
        <div class="inputText__icon"><i class="fas" :class="iconClass"></i></div>
        <v-suggest class="autocompleteAirport__container"
                   v-model="selected"
                   :ref="name"
                   :data="airports"
                   :delay="0.5"
                   :show="true"
                   v-validate="'required'"
                   :data-vv-as="label"
                   :full-list="fullList"
                   :name="name"
                   :id="name"
                   align="right"
                   @values="notify"
                   @clear="$emit('input', '')"
                   :placeholder="$t(`placeholder_${placeholder || name}`)"
        >
          <template #default="{ row }">
            <div class="autocompleteAirport__suggest">
              <div class="autocompleteAirport__suggestCity" v-if="display.city_code || display.city_name">
                <strong v-if="display.city_code" class="mr-1 --code" v-text="row.airport.city.code"></strong>
                <span v-if="display.city_name" v-text="row.airport.city.description"></span>
              </div>
              <div class="autocompleteAirport__suggestAirport" v-if="display.airport_code || display.airport_name">
                <i class="fas fa-city mr-2 fa-sm"></i>
                <strong v-if="display.airport_code" class="--code" v-text="row.airport.code"></strong>
                <span v-if="display.airport_name" class="ml-1" v-text="$t(row.airport.description).toUpperCase()"></span>
              </div>
              <div class="autocompleteAirport__suggestCountry" v-if="display.country_code || display.country_name">
                <i class="fas fa-flag mr-2 fa-sm"></i>
                <strong v-if="display.country_code" class="mr-1 --code" v-text="row.airport.city.country.code"></strong>
                <span v-if="display.country_name" v-text="row.airport.city.country.description"></span>
              </div>
            </div>
          </template>
        </v-suggest>
      </div>
      <span class="inputText__feedback" v-if="errors.first(name)">{{ errors.first(name) }}</span>
    </div>
  </div>
</template>

<script>
import { Suggest } from 'v-suggest'

export default {
  name: 'AutocompleteAirport',
  components: {
    'v-suggest': Suggest
  },
  inject: ['$validator'],
  props: {
    name: {
      required: true,
      type: String
    },
    label: {
      required: true,
      type: String
    },
    airports: {
      required: true
    },
    display: {
      required: true
    },
    value: {
      required: false
    },
    iconClass: {
      required: false,
      type: String
    },
    fullList: {
      required: false,
      default: false
    },
    showInputLabel: {
      required: false
    },
    default: {
      required: false,
      default: null
    },
    placeholder: {
      required: false
    }
  },
  data () {
    return {
      selected: ''
    }
  },
  methods: {
    checkInput: function () {
      if (!this.airports.find(x => x.name === this.selected)) {
        this.$refs[this.name].clear()
      }
    },
    notify: function (payload) {
      this.$emit('input', payload?.airport.code)
    },
  },
  mounted () {
    if (this.default) {
      let airportSelected = this.airports.find(i=>i.airport.code === this.default)
      this.selected = airportSelected ? airportSelected.name : this.default
    } else if (this.value != '') {
      let airportSelected = this.airports.find(i=>i.airport.code === this.value)
      this.selected = airportSelected ? airportSelected.name : this.value
      this.notify(airportSelected)
    }
    document.querySelector(`#${this.name} input`).className = 'inputText__input'
    document.querySelector('.v-suggest').className = ''
    this.$refs[this.name].$refs.drop.$on('show', e => this.$store.dispatch('notifyOverflowToParent', e))
  },
  beforeDestroy() {
    this.$refs[this.name].$refs.drop.$off('show', this.$store.dispatch('notifyOverflowToParent'))
  },
  watch: {
    selected: function () {
      setTimeout(() => {
        let dropdownelementRect = this.$refs[this.name].$refs.drop.$refs.dropdown.getBoundingClientRect()
        let suggestElementRect = this.$refs[this.name].$refs.drop.$el.getBoundingClientRect()
        if (suggestElementRect.bottom > (dropdownelementRect.bottom - dropdownelementRect.height)) {
          let diff = suggestElementRect.bottom - dropdownelementRect.bottom - suggestElementRect.height - 5
          let newTop = +this.$refs[this.name].$refs.drop.styleSheet.top.split('px')[0] + diff
          this.$refs[this.name].$refs.drop.styleSheet.top = `${newTop}px`
          this.$refs[this.name].$refs.drop.adjust()
        }
      }, (this.$refs[this.name].delay * 1000))
    },
    value: function (newValue) {
      let airportSelected = this.airports.find(i=> i.airport.code === newValue)
      this.selected = airportSelected ? airportSelected.name : ''
      this.$emit('input', airportSelected?.airport.code || '')
    }
  }
}
</script>

<style lang="sass">
// \:root
.autocompleteAirport
  margin-bottom: 0
  width: 100%
  &__container
    display: flex
    width: 100%
  &__suggest
    word-break: break-word
    display: flex
    flex-wrap: wrap
    &Airport, &City, &Country
      display: flex
      .--code
        flex-shrink: 0
    &Airport, &Country
      width: auto
      align-items: center
      font-size: var(--font-size-xs)
    &City
      width: 100%
      margin-bottom: .25rem
    &Country
      margin-left: .5rem
    i
      opacity: .4
  .inputText
    &__input
      padding: .5rem 2rem .5rem 2.75rem
      text-overflow: ellipsis
      margin-bottom: 0
  .sg-clear
    position: absolute
    right: 0
    top: 0
    cursor: pointer
    height: 100%
    width: auto
    line-height: 1
    padding: .5rem 0
    font-size: var(--font-size-base)
    span
      display: none !important
    &::after
      content: '\f00d'
      display: flex
      align-items: center
      font-style: normal
      font-variant: normal
      text-rendering: auto
      line-height: 1
      font-family: 'Font Awesome 5 Pro'
      font-weight: 900
      position: absolute
      top: 0
      right: 1rem
      bottom: 0
      z-index: 10
      opacity: 0.5
div.v-dropdown-container
  background-color: var(--color-surface)
  color: var(--color-onSurface)
  z-index: 10000
  box-shadow: var(--z-1)
  ul.sg-results
    padding: 0
    font-family: inherit
    li.sg-results__row, .sg-over
      color: var(--color-onSurface)
    li.sg-results__row
      padding: 10px
      border-bottom-style: solid
      border-bottom-color: var(--color-overlay-10)
      border-bottom-width: 1px
      color: var(--color-onSurface)
      &.sg-over
        background-color: var(--color-overlay-05) !important
        color: var(--color-onSurface) !important
        &:focus, &:active
          background-color: var(--color-overlay-20)
@media (min-width: 768px)
  .autocompleteAirport
    flex-basis: calc(50% - 0.5rem)
    &.--origin
      margin-right: 1rem
@media (min-width: 992px)
  .autocompleteAirport
    margin-right: .5rem
    margin-bottom: 0
    &.--origin
      margin-right: .5rem
</style>
